// THE SHA-256 OF THE WORDS AN OWNER ANSWERED BESIDE (the house consent pattern; ACC-3a's A9 tick, ACC-3b's G5 and G6).
//
// The server records an email answer only against the hash of a sentence it issued (`functions/src/v2/email/wording.ts`, EM-1),
// so what is hashed here is the held sentence's own text — the words on the page — and nothing composed around it. Null
// where the browser offers no Web Crypto: no hash, no record (the server would refuse one it cannot resolve anyway).

export async function textSha256(text: string): Promise<string | null> {
  try {
    const digest = await globalThis.crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, "0")).join("");
  } catch {
    return null;
  }
}
